import React, { FC, useState } from "react";
import styles from "./Dropper.module.css";
import useComponentVisible from "../../hooks/useComponentVisible";
import Share from "../../pages/cnp/Share/Share";
import { Modal } from "../Modal/Modal";

interface DropperProps {
  invoiceId: string;
  invoiceCreateDate: string;
}

// TODO: make the dropper accept options dynamically
const Dropper: FC<DropperProps> = ({ invoiceId, invoiceCreateDate }) => {
  const [modal, setModal] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  const onShare = (): Promise<any> => {
    return new Promise((resolve) => {
      resolve("doNothing");
    }); // do nothing on share
  };
  const handleClick = () => {
    setIsComponentVisible(!isComponentVisible);
    setModal(!modal);
  };

  return (
    <div className={styles.Test}>
      <div className={styles.Dots} onClick={handleClick} role="button" onKeyDown={() => {}} tabIndex={0}>
        <div className={styles.Dot} />
        <div className={styles.Dot} />
        <div className={styles.Dot} />
        <div ref={ref}>
          {isComponentVisible && (
            <div className={styles.Options} style={modal ? { display: "flex" } : { display: "none" }}>
              <ol>
                {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                <li onKeyDown={() => {}} onClick={() => setShowShare(true)}>
                  Share
                </li>
              </ol>
            </div>
          )}
        </div>
      </div>
      <Modal
        content={
          <Share
            onDone={() => setShowShare(false)}
            invoiceId={invoiceId}
            invoiceCreateDate={invoiceCreateDate}
            onShare={onShare}
          />
        }
        title="Share iK Invoice"
        isOpen={showShare}
      />
    </div>
  );
};

export default Dropper;
